/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * cmsservice - Student APIs
 * Minimal OpenAPI spec for selected student APIs, derived from Retrofit interface in `ApiService.kt`.

 * OpenAPI spec version: 1.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ChapterResponseBody,
  GetChaptersForSubjectsBody,
  GetPlaylistsForParams,
  PlaylistsForResponse,
  TestVideoViewSolutionResponse,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns video playlists for the given grade, exam and playlist type.
 * @summary Get video playlists for a student
 */
export const getPlaylistsFor = (
  params: GetPlaylistsForParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PlaylistsForResponse>(
    { url: `/video_playlist/get/playlistsFor`, method: "GET", params, signal },
    options,
  );
};

export const getGetPlaylistsForQueryKey = (params?: GetPlaylistsForParams) => {
  return [
    `/video_playlist/get/playlistsFor`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlaylistsForQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlaylistsFor>>,
  TError = void,
>(
  params: GetPlaylistsForParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlaylistsFor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlaylistsForQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlaylistsFor>>> = ({
    signal,
  }) => getPlaylistsFor(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlaylistsFor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlaylistsForQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlaylistsFor>>
>;
export type GetPlaylistsForQueryError = void;

export function useGetPlaylistsFor<
  TData = Awaited<ReturnType<typeof getPlaylistsFor>>,
  TError = void,
>(
  params: GetPlaylistsForParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlaylistsFor>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlaylistsFor>>,
          TError,
          Awaited<ReturnType<typeof getPlaylistsFor>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlaylistsFor<
  TData = Awaited<ReturnType<typeof getPlaylistsFor>>,
  TError = void,
>(
  params: GetPlaylistsForParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlaylistsFor>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlaylistsFor>>,
          TError,
          Awaited<ReturnType<typeof getPlaylistsFor>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPlaylistsFor<
  TData = Awaited<ReturnType<typeof getPlaylistsFor>>,
  TError = void,
>(
  params: GetPlaylistsForParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlaylistsFor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get video playlists for a student
 */

export function useGetPlaylistsFor<
  TData = Awaited<ReturnType<typeof getPlaylistsFor>>,
  TError = void,
>(
  params: GetPlaylistsForParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlaylistsFor>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPlaylistsForQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns chapters for given exam, subject and grade criteria used in CYOT assessments.

 * @summary Get chapters for exam subject grades
 */
export const getChaptersForSubjects = (
  examId: number,
  getChaptersForSubjectsBody: GetChaptersForSubjectsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChapterResponseBody>(
    {
      url: `/examtoc/getChaptersForExamSubjectGrades/${examId}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getChaptersForSubjectsBody,
      signal,
    },
    options,
  );
};

export const getGetChaptersForSubjectsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getChaptersForSubjects>>,
    TError,
    { examId: number; data: GetChaptersForSubjectsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getChaptersForSubjects>>,
  TError,
  { examId: number; data: GetChaptersForSubjectsBody },
  TContext
> => {
  const mutationKey = ["getChaptersForSubjects"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getChaptersForSubjects>>,
    { examId: number; data: GetChaptersForSubjectsBody }
  > = (props) => {
    const { examId, data } = props ?? {};

    return getChaptersForSubjects(examId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetChaptersForSubjectsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getChaptersForSubjects>>
>;
export type GetChaptersForSubjectsMutationBody = GetChaptersForSubjectsBody;
export type GetChaptersForSubjectsMutationError = void;

/**
 * @summary Get chapters for exam subject grades
 */
export const useGetChaptersForSubjects = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getChaptersForSubjects>>,
      TError,
      { examId: number; data: GetChaptersForSubjectsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getChaptersForSubjects>>,
  TError,
  { examId: number; data: GetChaptersForSubjectsBody },
  TContext
> => {
  const mutationOptions = getGetChaptersForSubjectsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns video solution details for a given viewSolutionId.
 * @summary Get video view solution
 */
export const getVideoViewSolution = (
  viewSolutionId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TestVideoViewSolutionResponse>(
    { url: `/videos/get_video/${viewSolutionId}`, method: "GET", signal },
    options,
  );
};

export const getGetVideoViewSolutionQueryKey = (viewSolutionId?: number) => {
  return [`/videos/get_video/${viewSolutionId}`] as const;
};

export const getGetVideoViewSolutionQueryOptions = <
  TData = Awaited<ReturnType<typeof getVideoViewSolution>>,
  TError = void,
>(
  viewSolutionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoViewSolution>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVideoViewSolutionQueryKey(viewSolutionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVideoViewSolution>>
  > = ({ signal }) =>
    getVideoViewSolution(viewSolutionId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!viewSolutionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVideoViewSolution>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVideoViewSolutionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVideoViewSolution>>
>;
export type GetVideoViewSolutionQueryError = void;

export function useGetVideoViewSolution<
  TData = Awaited<ReturnType<typeof getVideoViewSolution>>,
  TError = void,
>(
  viewSolutionId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoViewSolution>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideoViewSolution>>,
          TError,
          Awaited<ReturnType<typeof getVideoViewSolution>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVideoViewSolution<
  TData = Awaited<ReturnType<typeof getVideoViewSolution>>,
  TError = void,
>(
  viewSolutionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoViewSolution>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideoViewSolution>>,
          TError,
          Awaited<ReturnType<typeof getVideoViewSolution>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVideoViewSolution<
  TData = Awaited<ReturnType<typeof getVideoViewSolution>>,
  TError = void,
>(
  viewSolutionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoViewSolution>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get video view solution
 */

export function useGetVideoViewSolution<
  TData = Awaited<ReturnType<typeof getVideoViewSolution>>,
  TError = void,
>(
  viewSolutionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideoViewSolution>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVideoViewSolutionQueryOptions(
    viewSolutionId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
